import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { getRequest } from 'Includes/api/apicall';
import { GET_URL } from 'Includes/urls';

function TaskBacklogUnassigned(props) {
  const [rows, setRows] = React.useState([]);
  const [rowCount, setRowCount] = React.useState(0);
  const [loading, setLoading] = React.useState(false);
  const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 10 });

  const loadData = React.useCallback(() => {
    setLoading(true);
    getRequest(
      GET_URL.tasks.api,
      {
        limit: paginationModel.pageSize,
        pageno: paginationModel.page + 1,
        task_stage_code: 'backlog',
        assigned_to_isnull: 1,
      },
      props
    )
      .then((response) => {
        if (response && response.status === 200) {
          setRows(response.data?.data || []);
          setRowCount(response.data?.count || 0);
        } else {
          setRows([]);
          setRowCount(0);
        }
      })
      .finally(() => setLoading(false));
  }, [paginationModel.page, paginationModel.pageSize, props]);

  React.useEffect(() => {
    loadData();
  }, [loadData]);

  const columns = [
    { field: 'title', headerName: 'Task', minWidth: 220, flex: 1 },
    { field: 'category', headerName: 'Category', minWidth: 140, flex: 0.7 },
    { field: 'priority', headerName: 'Priority', minWidth: 110, flex: 0.5 },
    { field: 'planned_date', headerName: 'Planned Date', minWidth: 140, flex: 0.6 },
    { field: 'deadline', headerName: 'Deadline', minWidth: 140, flex: 0.6 },
    {
      field: 'assigned_to_name',
      headerName: 'Assigned To',
      minWidth: 170,
      flex: 0.7,
      renderCell: (params) => params.value || 'Unassigned',
    },
    { field: 'sprint_name', headerName: 'Sprint', minWidth: 180, flex: 0.8 },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700}>Backlog - Unassigned</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Tasks in `Backlog` stage that are not assigned to anyone.
      </Typography>

      <Paper sx={{ p: 2, borderRadius: 2 }}>
        <DataGrid
          autoHeight
          rows={rows}
          columns={columns}
          loading={loading}
          pagination
          paginationMode="server"
          rowCount={rowCount}
          pageSizeOptions={[10, 20, 50]}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          disableRowSelectionOnClick
        />
      </Paper>
    </Box>
  );
}

export default TaskBacklogUnassigned;

